import { formatDate } from "./formatDate";

const DataToObjChartCount = (response) => {
  let dayLabel = [];
  let chiamateEffettuate = [];
  let chiamateRicevute = [];
  let chiamateTentativi = [];

  response.map((x) => {
    dayLabel.push(
      formatDate(x.dataGiornoRange)
    );
    chiamateEffettuate.push(x.numeroChiamateEffettuate);
    chiamateRicevute.push(x.numeroChiamateRicevute);
    chiamateTentativi.push(x.numeroChiamateTentativi);
    return null;
  });
  return ({
    labels: dayLabel,
    datasets: [
      {
        label: "Chiamate Effettuate",
        data: chiamateEffettuate,
        backgroundColor: "rgba(38, 224, 109, 0.8)",
        borderColor: "rgba(38, 224, 109, 0.8)",
        pointBackgroundColor: "rgba(38, 224, 109, 0.8)",
        pointBorderColor: "#000",
        pointHoverBackgroundColor: "#000",
        pointHoverBorderColor: "rgba(38, 224, 109, 0.8)",
        tooltipLabelColor: "rgba(38, 224, 109, 0.8)",
        fill: false,
        cubicInterpolationMode: 'monotone',
        tension: 0.4
      },
      {
        label: "Chiamate Ricevute",
        data: chiamateRicevute,
        backgroundColor: "rgba(246, 194, 62, 0.8)",
        borderColor: "rgba(246, 194, 62, 0.8)",
        pointBackgroundColor: "rgba(246, 194, 62, 0.8)",
        pointBorderColor: "#000",
        pointHoverBackgroundColor: "#000",
        pointHoverBorderColor: "rgba(246, 194, 62, 0.8)",
        tooltipLabelColor: "rgba(246, 194, 62, 0.8)",
        fill: false,
        cubicInterpolationMode: 'monotone',
        tension: 0.4
      },
      {
        label: "Chiamate Perse",
        data: chiamateTentativi,
        backgroundColor: "rgba(255, 0, 0, 0.801)",
        borderColor: "rgba(255, 0, 0, 0.801)",
        pointBackgroundColor: "rgba(255, 0, 0, 0.801)",
        pointBorderColor: "#000",
        pointHoverBackgroundColor: "#000",
        pointHoverBorderColor: "rgba(255, 0, 0, 0.801)",
        tooltipLabelColor: "rgba(255, 0, 0, 0.801)",
        fill: false,
        cubicInterpolationMode: 'monotone',
        tension: 0.4
      },
    ],
  });
};

const DataToObjChartDurata = (response) => {
  let dayLabel = [];
  let durataChiamateEffettuate = [];
  let durataChiamateRicevute = [];
  response.map((x) => {
    dayLabel.push(
      formatDate(x.dataGiornoRange)
    );
    durataChiamateEffettuate.push(x.durataChiamateEffettuate);
    durataChiamateRicevute.push(x.durataChiamateRicevute);
    return null;
  });
  return ({
    labels: dayLabel,
    datasets: [
      {
        label: "Durata Chiamate Effettuate",
        data: durataChiamateEffettuate,
        backgroundColor: "rgba(38, 224, 109, 0.8)",
        borderColor: "rgba(38, 224, 109, 0.8)",
        pointBackgroundColor: "rgba(38, 224, 109, 0.8)",
        pointBorderColor: "#000",
        pointHoverBackgroundColor: "#000",
        pointHoverBorderColor: "rgba(38, 224, 109, 0.8)",
        tooltipLabelColor: "rgba(38, 224, 109, 0.8)",
        fill: false,
        cubicInterpolationMode: 'monotone',
        tension: 0.4
      },
      {
        label: "Durata Chiamate Ricevute",
        data: durataChiamateRicevute,
        backgroundColor: "rgba(246, 194, 62, 0.8)",
        borderColor: "rgba(246, 194, 62, 0.8)",
        pointBackgroundColor: "rgba(246, 194, 62, 0.8)",
        pointBorderColor: "#000",
        pointHoverBackgroundColor: "#000",
        pointHoverBorderColor: "rgba(246, 194, 62, 0.8)",
        tooltipLabelColor: "rgba(246, 194, 62, 0.8)",
        fill: false,
        cubicInterpolationMode: 'monotone',
        tension: 0.4
      },
    ],
  });
};

const DataToObjChartDurataDevice = (response = []) => {
  let result = {};
  let dayLabel = [];
  let dataSetDeviceToChart = [];
  let denominazione = "";
  let coloreChart = "";
  
  response.map((resp, index) => {
    let durataChiamateEffettuate = [];
    denominazione = resp.denominazione;
    coloreChart = resp.coloreChart;

    resp.chiamateEffettuate.map((dati) => {
      if (index === 0) {
        dayLabel.push(
          formatDate(dati.dataGiornoRange)
        );
      }
      durataChiamateEffettuate.push(dati.durataChiamateEffettuate);
      return null;
    });

    dataSetDeviceToChart.push(
      ObjectForChart(denominazione, durataChiamateEffettuate, coloreChart)
    );

    result = {
      labels: dayLabel,
      datasets: dataSetDeviceToChart,
    };
    return null;
  });

  return result;
};

export {DataToObjChartCount,DataToObjChartDurata,DataToObjChartDurataDevice};

const ObjectForChart = (denominazione, durataChiamateEffettuate, coloreChart) => {

  return {
    label: denominazione,
    data: durataChiamateEffettuate,
    backgroundColor: coloreChart,
    borderColor: coloreChart,
    pointBackgroundColor: coloreChart,
    pointBorderColor: "#000",
    pointHoverBackgroundColor: "#000",
    pointHoverBorderColor: coloreChart,
    tooltipLabelColor: coloreChart,
    fill: false,
    cubicInterpolationMode: 'monotone',
    tension: 0.4
  };
};
